import { Vue, Component } from 'vue-property-decorator'
import cms from '@/cms'
import { Getter } from 'vuex-class'

// this pages should not be redirected
const APP_WHITE_LIST_ROUTES = ['Home', 'Chart', 'LoginPage']

@Component
export class RouteGuardHandler extends Vue {
  @Getter campaignIsCompetition!: boolean
  @Getter authUserName!: string

  @Getter campaignSetlistUserPlaylistId!: string
  @Getter campaignSetlistPlaylistId!: string
  @Getter campaignTrackIdsSelected!: number[]
  @Getter campaignIsEnded!: boolean

  get isCurrentFrame (): boolean {
    return window.self !== window.top
  }

  $routeGuardApp () {
    console.log('Guard')
    if (this.campaignIsEnded && !this.$route.meta?.noEndRedirect) {
      this.$router.push('/end')

      return
    }

    const isWhiteListed = this.$route.name && APP_WHITE_LIST_ROUTES.includes(this.$route.name.toString())

    if (isWhiteListed) {

    }

    // if (!this.authUserName) {
    //   this.$router.push('/')
    // }

    // if (cms.newsletter.enabled || this.campaignIsCompetition) {
    //   console.log('Newsletter enabled')
    //   this.$router.push('/newsletter')

    //   return
    // }

    // if (this.$route.path !== '/breaker/search') {
    //   this.$router.push('/breaker/search')
    // }
  }

  $routeGuardLoginNextUrl (): string {
    if (cms.newsletter.enabled || this.campaignIsCompetition) {
      return 'newsletter'
    }

    return '/breaker/search'
  }

  $routeGuardResult (): boolean {
    if (this.isCurrentFrame === false && (!this.campaignSetlistUserPlaylistId || !this.campaignSetlistPlaylistId)) {
      this.$router.push('/')

      return false
    }

    return true
  }

  $routeGuardLogin (): boolean {
    if (this.campaignTrackIdsSelected.length === 0) {
      this.$router.push('/')

      return false
    }

    return true
  }

  $routeGuardPlaylistFavorite (): boolean {
    if (this.campaignTrackIdsSelected.length === 0) {
      this.$router.push('/')

      return false
    }

    return true
  }

  $routeGuardPlaylistSort (): boolean {
    if (this.campaignTrackIdsSelected.length === 0) {
      this.$router.push('/')

      return false
    }

    return true
  }
}
